export default __webpack_public_path__ + "static/media/btn_google_store.2c1a4e6c.png";